import React, { ReactNode } from 'react';
import { Icon, IconName } from '@estimateone/frontend-components';
import styles from './styles.scss';

const normalisePercentage = (percentComplete: number) => {
  if (percentComplete > 100) {
    return 100;
  }

  if (percentComplete < 0) {
    return 0;
  }

  return Math.floor(percentComplete);
};

const ProgressBar = ({
  children,
  percentComplete,
}: {
  children?: ReactNode;
  percentComplete: number;
}) => {
  const percent = normalisePercentage(percentComplete);
  const complete = percent === 100;

  return (
    <div className={styles.container}>
      <div className={styles.bar}>
        <div title="progressPercentFill" className={styles.fill} style={{ width: `${percent}%` }} />
        <div className={styles.content}>
          <div className={styles.icon}>
            <Icon name={complete ? IconName.Check : IconName.Upload} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
